import React, { useState } from "react";
import { useCommentData } from "./CommentDataContext";
import { Edit } from "@mui/icons-material";
import "./CommentDetails.css";

const CommentDetails = () => {
  const [editText, setEditText] = useState("");
  const [editIndex, setEditIndex] = useState(null);

  const { activeTab, username, selectedQuery, editable, setEditable } =
    useCommentData();

  const handleSaveEditedComment = (index) => {
    const updatedDescription = selectedQuery.description.map((comment, i) => {
      if (i === index) {
        return { ...comment, text: editText };
      }
      return comment;
    });
    window.canvasEngine.FeatureRenderer.addEditedComment(
      updatedDescription,
      activeTab,
      selectedQuery.id
    );
    setEditIndex(null);
    setEditText("");
    setEditable(false);
  };
  const bubbleColorFor = (name, isOwn) => {
    const PALETTE = [
      [210, 60, 92],
      [215, 55, 91],
      [220, 55, 90],
      [205, 55, 92],
      [200, 55, 91],
      [225, 50, 90],
      [195, 50, 92],
      [230, 45, 90],
      [208, 50, 91],
      [218, 50, 90],
    ];
    let hash = 0;
    for (let i = 0; i < (name || "").length; i++) {
      hash = (name.charCodeAt(i) + ((hash << 5) - hash)) | 0;
    }
    const idx = Math.abs(hash) % PALETTE.length;
    let [h, s, l] = PALETTE[idx];
    if (isOwn) l = Math.max(70, l - 8);
    return `hsl(${h}, ${s}%, ${l}%)`;
  };

  return (
    <div className="comment-details-container">
      {selectedQuery?.description?.length === 0 ? (
        <p className="no-comments-text">No comments yet.</p>
      ) : (
        selectedQuery?.description.map((comment, index) => {
          const isOwn = comment.username === username;
          const color = bubbleColorFor(comment.username, isOwn);

          return (
            <div
              key={index}
              className={`message-row ${isOwn ? "sent" : "received"}`}
            >
              <div className="bubble" style={{ backgroundColor: color }}>
                {editIndex === index ? (
                  <>
                    <textarea
                      className="edit-textarea"
                      value={editText}
                      onChange={(e) => setEditText(e.target.value)}
                    />
                    <div className="edit-actions">
                      <button
                        onClick={() => {
                          setEditIndex(null);
                          setEditText("");
                        }}
                        className="cancel-button"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={() => handleSaveEditedComment(index)}
                        className="save-button"
                      >
                        Save
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <p className="message-text">{comment.text}</p>

                    {editable && isOwn && (
                      <button
                        onClick={() => {
                          setEditIndex(index);
                          setEditText(comment.text);
                        }}
                        className="edit-icon-button"
                        title="Edit"
                      >
                        <Edit fontSize="small" />
                      </button>
                    )}

                    <div className="message-meta">
                      <span className="meta-username">{comment.username}</span>
                      <span className="meta-dot">•</span>
                      <span className="meta-datetime">
                        {comment.date} {comment.time}
                      </span>
                    </div>
                  </>
                )}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default CommentDetails;
